export const SESSION_PROPAGATE_FORM_NAME = 'sessionPropagateForm';
